module.exports = __webpack_public_path__ + "static/media/trieste-14.d68af276.jpg";